
// @ts-nocheck
/* eslint-disable */
import { computed, inject, defineComponent } from 'vue'
import { useGlobalConfig } from '@/components/utils/util'
import { isValidComponentSize } from '@/components/utils/validators'
import { getThemeCls } from '@/utils/theme'
// import { elFormKey, elFormItemKey } from '@/components/form'

import type { PropType } from 'vue'
import type { ElFormContext, ElFormItemContext } from '@/components/form'

type IButtonType = PropType<
  | 'primary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'text'
  | 'gradient'
  | 'green'
  | 'default'
  | 'gradient-game'
  | 'warning-game'
  | 'touch-point'
  | 'touch-point-lock'
  | 'gray',
  | 'orange',
  | 'purple'
>
type IButtonNativeType = PropType<'button' | 'submit' | 'reset'>

interface IButtonProps {
  type: string
  size: string
  icon: string
  nativeType: string
  loading: boolean
  disabled: boolean
  plain: boolean
  autofocus: boolean
  round: boolean
  circle: boolean
  commandName: string
  commandArgument: string
  isActive: Boolean
}

type EmitFn = (evt: Event) => void

export default defineComponent({
  name: 'MsButton',

  props: {
    type: {
      type: String as IButtonType,
      default: 'default',
      validator: (val: string) => {
        return [
          'default',
          'primary',
          'success',
          'warning',
          'info',
          'danger',
          'text',
          'gradient',
          'gradient-game',
          'warning-game',
          'touch-point',
          'touch-point-lock',
          'green',
          'gray',
          'orange',
          'purple'
        ].includes(val)
      },
    },
    // eslint-disable-next-line vue/require-default-prop
    size: {
      type: String as PropType<ComponentSize>,
      validator: isValidComponentSize,
    },
    icon: {
      type: String,
      default: '',
    },
    nativeType: {
      type: String as IButtonNativeType,
      default: 'button',
      validator: (val: string) => {
        return ['button', 'submit', 'reset'].includes(val)
      },
    },
    loading: Boolean,
    disabled: Boolean,
    plain: {
      type: Boolean,
      default: false,
    },
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean,

    commandName: {
      type: String,
      default: '',
    },

    commandArgument: {
      type: String,
      default: '',
    },

    isActive: {
      type: Boolean,
      default: false
    }
  },

  emits: ['click'],

  setup(props, ctx) {
    const $ELEMENT = useGlobalConfig()

    // const elForm = inject(elFormKey, {} as ElFormContext)
    // const elFormItem = inject(elFormItemKey, {} as ElFormItemContext)

    const buttonSize = computed(() => {
      return props.size || $ELEMENT.size
    })
    const buttonDisabled = computed(() => {
      return props.disabled
    })

    const themeCls = computed(() => getThemeCls())

    // methods
    const handleClick = (evt) => {
      ctx.emit('click', evt)
    }

    return {
      buttonSize,
      buttonDisabled,
      handleClick,
      themeCls,
    }
  },
})
